module.exports = __webpack_public_path__ + "static/img/EU_EAKR_SV_vertical_20mm_rgb.1f6b8d3.png";